import React from "react";

export default function DateTime(props) {
  let weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let day = weekdays[props.dateTime.getDay()];
  let hours = props.dateTime.getHours();
  if (hours < 10) {
    hours = `0${hours}`;
  }
  let minutes = props.dateTime.getMinutes();
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  return (
    <div>
      {day} | {hours}:{minutes}
    </div>
  );
}
